<template>
    <form-template @submit="proceed">
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">User Information</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <div class="grid grid-cols-2 gap-5 md:gap-10">
                <div class="col-span-2 md:col-span-1">
                    <biller-radio @select="(val) => (meter = val)" value="PREPAID" :active="meter === 'PREPAID'">
                        <p class="text-grey-300 text-sm">PrePaid Meter</p>
                    </biller-radio>
                </div>
                <div class="col-span-2 md:col-span-1">
                    <biller-radio @select="(val) => (meter = val)" value="POSTPAID" :active="meter === 'POSTPAID'">
                        <p class="text-grey-300 text-sm">PostPaid Meter</p>
                    </biller-radio>
                </div>
            </div>
        </div>
        <template v-if="showCategories.length">
            <div class="col-span-4 md:col-span-1">
                <p class="text-smoke-dark text-sm">Select Provider</p>
            </div>
            <div class="col-span-4 md:col-span-3">
                <div class="grid grid-cols-4 gap-3 w-full">
                    <template v-if="!loadCategories">
                        <div
                            class="col-span-2 md:col-span-1"
                            v-for="category in slicedCategories"
                            :key="category.billername"
                        >
                            <biller-radio
                                @select="(val) => selectCategory(val, category)"
                                :value="category.billername"
                                :active="selectedCategory === category.billername"
                            >
                                <p
                                    :class="
                                        `text-xs text-center ${
                                            selectedCategory === category.name ? 'text-purple' : 'text-grey-300'
                                        }`
                                    "
                                >
                                    {{ category.billername.split('-')[0] }}
                                </p>
                            </biller-radio>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-span-2 md:col-span-1" v-for="index in 3" :key="index">
                            <div
                                class="flex items-center justify-center border rounded-lg px-4 py-8 h-16 bg-transparent border-snow-200 w-full"
                            >
                                <div class="skeleton"></div>
                            </div>
                        </div>
                    </template>
                    <div class="col-span-2 md:col-span-1">
                        <others-drop-down
                            :otherItems="showCategories"
                            @selectedItem="selectOther"
                            :value="selectedOther.billername || 'Others'"
                            :active="(selectedOther.billername || 'Others') === selectedCategory"
                            text="Categories"
                        >
                            <template v-slot:selected>
                                <template v-if="selectedOther.billername !== undefined">
                                    <div class="flex items-center">
                                        <p class="text-xs text-grey-300 text-center">
                                            {{ selectedOther.billername.split('-')[0] }}
                                        </p>
                                    </div>
                                </template>
                                <template v-else>
                                    Others
                                </template>
                            </template>
                        </others-drop-down>
                    </div>
                </div>
            </div>
        </template>

        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Meter Number</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-input type="number" placeholder="Input Meter Number" v-model="data.customer_id" required />
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Electricity Phone Number</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-input
                type="number"
                placeholder="Input Phone Number"
                v-model="data.electricity_phone_number"
                required
            />
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Amount</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-input
                placeholder="Input Amount"
                largeValue
                type="text"
                :value="input"
                @input="updateAmount"
                required
            >
                <template v-slot:append>
                    <img src="@/assets/svg/naira-icon.svg" alt="Nigerian Naira icon" />
                </template>
            </biller-input>
        </div>
    </form-template>
</template>

<script>
import { formatAmount } from '@/util/formatAmount'
import { mapActions, mapGetters } from 'vuex'
import OthersDropDown from '@/components/OthersDropdown'
export default {
    metaInfo: {
        title: 'Electricity',
    },
    components: {
        OthersDropDown,
    },
    data() {
        return {
            meter: '',
            data: {
                service_category_id: 0,
                product_name: '',
                customer_id: '',
                electricity_phone_number: '',
                amount: '',
            },
            showCategories: [],
            loadCategories: false,
            selectedOther: {},
            selectedCategory: '',
            input: '',
        }
    },

    mounted() {
        this.getCategories()
    },

    computed: {
        ...mapGetters('Bill', {
            categories: 'GET_ELECTRICITY_CATEGORIES',
        }),

        slicedCategories: {
            get: function() {
                return this.showCategories.slice(0, 3)
            },
        },
    },

    watch: {
        meter: function(newValue) {
            this.showCategories = this.categories.filter((val) =>
                val.billername.toLowerCase().includes(newValue.toLowerCase())
            )
        },

        input: function(newValue) {
            let val = newValue
                .toString()
                .split(',')
                .join('')
            this.data.amount = parseInt(val)
            this.input = formatAmount(val)
        },
    },

    methods: {
        selectCategory(val, details) {
            this.selectedCategory = val
            this.data.service_category_id = details.service_category_id
            this.data.product_name = val
        },

        ...mapActions('Bill', {
            getCategories: 'FETCH_ELECTRICITY_CATEGORIES',
        }),

        ...mapActions('Message', {
            setMessage: 'SET_MESSAGE',
            setMessageType: 'SET_MESSAGE_TYPE',
            setWarning: 'SET_WARNING',
        }),

        selectOther(val) {
            this.selectedCategory = val.billername
            this.selectedOther = val
            this.data.service_category_id = val.service_category_id
            this.data.product_name = val.billername
        },
        updateAmount(val) {
            this.input = val.replace(/[^\d]/g, '')
            this.$forceUpdate()
        },
        proceed(val) {
            if (this.data.customer_id.length < 13) {
                this.setMessage('The Meter Number must be 13 digits')
                this.setWarning('warning')
            } else if (this.data.product_name && this.data.service_category_id) {
                const fullData = Object.assign(this.data, val)
                this.$emit('proceed', fullData)
            } else {
                this.setMessageType(false)
                this.setMessage('Please complete the form')
            }
        },
    },
}
</script>

<style scoped>
.skeleton {
    width: 50px;
    height: 15px;
    border-radius: 10px;
    animation: pulse-bg 1s ease-in-out infinite normal both;
}
</style>
